/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const AddressIssueDTOCodeEnum = {
    NameMissing: 'NAME_MISSING',
    NameSingleToken: 'NAME_SINGLE_TOKEN',
    NameRepeated: 'NAME_REPEATED',
    NamePlaceholder: 'NAME_PLACEHOLDER',
    NameCompanyLike: 'NAME_COMPANY_LIKE',
    NameNonLatin: 'NAME_NON_LATIN',
    PhoneMissing: 'PHONE_MISSING',
    PhoneInvalid: 'PHONE_INVALID',
    PhonePlaceholder: 'PHONE_PLACEHOLDER',
    StreetMissing: 'STREET_MISSING',
    StreetNoNumber: 'STREET_NO_NUMBER',
    StateMissing: 'STATE_MISSING'
};
/**
 * @export
 */
export const AddressIssueDTOSeverityEnum = {
    Error: 'ERROR',
    Warn: 'WARN'
};
/**
 * Check if a given object implements the AddressIssueDTO interface.
 */
export function instanceOfAddressIssueDTO(value) {
    return true;
}
export function AddressIssueDTOFromJSON(json) {
    return AddressIssueDTOFromJSONTyped(json, false);
}
export function AddressIssueDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'] == null ? undefined : json['code'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'field': json['field'] == null ? undefined : json['field'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}
export function AddressIssueDTOToJSON(json) {
    return AddressIssueDTOToJSONTyped(json, false);
}
export function AddressIssueDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'severity': value['severity'],
        'field': value['field'],
        'message': value['message'],
    };
}
